import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowLeftIcon, ArrowRightIcon, AwardIcon, CheckCircle2Icon, CalendarIcon, UtensilsIcon, GraduationCapIcon } from 'lucide-react';
import { ScrollReveal } from '../components/ScrollReveal';
import { useBooking } from '../contexts/BookingContext';
export function IntensivCurriculumPage() {
  const {
    openBooking
  } = useBooking();
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-968">
      <Navbar data-id="element-969" />

      <main className="flex-grow pt-24 pb-20" data-id="element-970">
        {/* Hero Section */}
        <div className="relative h-[50vh] min-h-[400px] md:h-[60vh] md:min-h-[500px] w-full mb-10 md:mb-16" data-id="element-971">
          <div className="absolute inset-0" data-id="element-972">
            <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="2N Intensiv Curriculum" className="w-full h-full object-cover" data-id="element-973" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/60 to-transparent" data-id="element-974"></div>
          </div>

          <div className="absolute inset-0 flex items-end pb-16" data-id="element-975">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-976">
              <Link to="/#kurse" className="inline-flex items-center text-white/80 hover:text-white font-semibold mb-8 transition-colors backdrop-blur-sm bg-white/10 px-4 py-2 rounded-full border border-white/20" data-id="element-977">
                <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-978" /> Zurück zur Übersicht
              </Link>

              <ScrollReveal variant="up" data-id="element-979">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 text-amber-400 text-sm font-extrabold uppercase tracking-wider mb-6 border border-amber-500/30 backdrop-blur-md" data-id="element-980">
                  <AwardIcon className="h-5 w-5" data-id="element-981" />
                  78 Fortbildungspunkte
                </div>
                <h1 className="text-3xl md:text-6xl lg:text-7xl font-extrabold text-white mb-4 tracking-tight" data-id="element-982">
                  2N Intensiv Curriculum
                </h1>
                <p className="text-lg md:text-2xl text-[#59d0d4] font-medium max-w-3xl" data-id="element-983">
                  Ästhetik, Funktion & Praxisführung
                </p>
              </ScrollReveal>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-984">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-985">
            {/* Main Content Column */}
            <div className="lg:col-span-8 space-y-8 md:space-y-12" data-id="element-986">
              {/* Intro */}
              <ScrollReveal variant="up" data-id="element-987">
                <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-100" data-id="element-988">
                  <h2 className="text-2xl font-extrabold text-slate-700 mb-6" data-id="element-989">
                    Wissenschaft und kollegiales Netzwerk vereint
                  </h2>
                  <div className="space-y-6 text-base sm:text-lg text-slate-600 font-medium leading-relaxed" data-id="element-990">
                    <p data-id="element-991">
                      Als Fortbildungsinstitut für Zahnärzte und Praxisteams ist
                      es uns ein besonderes Anliegen, über die fachliche
                      Komponente hinaus, in entspannter Atmosphäre zu
                      netzwerken, sowie Erfahrungen und Know-How gegenseitig
                      auszutauschen. Hierfür möchten wir im Rahmen unserer
                      Fortbildungen einen Raum schaffen, der Wissenschaft und
                      kollegiales Netzwerk vereint.
                    </p>
                    <p data-id="element-992">
                      Unser 2N Intensiv-Curriculum Ästhetik und Funktion bildet
                      Sie zu den Themen Weiße Ästhetik, Rote Ästhetik, Funktion
                      sowie Praxisführung fort. Zusätzlich dazu bietet es Ihnen
                      die Möglichkeit sich unter Kollegen auszutauschen und
                      wertvolle Impulse für Ihren Praxisalltag mit nach Hause zu
                      nehmen.
                    </p>
                    <p data-id="element-993">
                      Kompetent und praxisnah stellen wir Ihnen Methoden vor,
                      die Sie direkt im Anschluss in Ihrer Praxis anwenden
                      können. Dabei vermitteln wir viele wichtige Tipps und
                      praktische Ideen, die kurzweilig anhand zahlreicher
                      Patientenfälle, Hands-on Elementen und Live-Behandlungen
                      demonstriert werden.
                    </p>
                  </div>
                </div>
              </ScrollReveal>

              {/* Ablauf & Bonus */}
              <ScrollReveal variant="up" data-id="element-994">
                <div className="bg-gradient-to-br from-[#3b7780] to-[#2d5f66] rounded-3xl p-8 md:p-12 shadow-xl text-white relative overflow-hidden" data-id="element-995">
                  <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#59d0d4] rounded-full mix-blend-screen filter blur-[60px] opacity-30" data-id="element-996"></div>

                  <div className="relative z-10" data-id="element-997">
                    <div className="flex items-center gap-4 mb-6" data-id="element-998">
                      <div className="bg-white/20 p-3 rounded-2xl backdrop-blur-sm" data-id="element-999">
                        <GraduationCapIcon className="w-8 h-8 text-[#59d0d4]" data-id="element-1000" />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-extrabold" data-id="element-1001">
                        Ablauf des Curriculums
                      </h2>
                    </div>

                    <p className="text-lg text-slate-200 font-medium leading-relaxed mb-8" data-id="element-1002">
                      Bei Buchung unseres Intensiv-Curriculums durchlaufen Sie
                      unsere Kursreihe mit den Themen Weiße Ästhetik, Rote
                      Ästhetik, Funktion und erfolgreiche Praxisführung.
                    </p>

                    <div className="bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm" data-id="element-1003">
                      <h3 className="text-[#59d0d4] font-extrabold text-xl mb-2" data-id="element-1004">
                        Alignertherapie
                      </h3>
                      <p className="text-white font-medium mb-4" data-id="element-1005">
                        Profitieren sie von einem zusätzlichen kostenfreien
                        Kurswochenende „Alignertherapie"
                      </p>
                      <p className="text-sm text-slate-300" data-id="element-1006">
                        <span className="line-through mr-2" data-id="element-1007">
                          Normalpreis: 1.650,-€ zzgl. MwSt.
                        </span>
                        <span className="font-bold text-white" data-id="element-1008">
                          Kostenfrei bei Buchung des Intensiv Curriculums.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              {/* Module & Termine */}
              <ScrollReveal variant="up" data-id="element-1009">
                <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-100" data-id="element-1010">
                  <div className="flex items-center gap-4 mb-8" data-id="element-1011">
                    <div className="bg-[#59d0d4]/15 p-3 rounded-2xl" data-id="element-1012">
                      <CalendarIcon className="w-8 h-8 text-[#3b7780]" data-id="element-1013" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-slate-700" data-id="element-1014">
                      Module & Termine 2026
                    </h2>
                  </div>

                  <div className="space-y-6" data-id="element-1015">
                    {[{
                    title: 'Modul 1: Experte für Weiße Ästhetik',
                    date: '17./18. April 2026',
                    label: 'White Aesthetics',
                    color: 'bg-[#59d0d4]/15 text-[#3b7780]'
                  }, {
                    title: 'Modul 2: Experte für Rote Ästhetik',
                    date: '03./04. Juli 2026',
                    label: 'Red Aesthetics',
                    color: 'bg-rose-100 text-rose-700'
                  }, {
                    title: 'Modul 3: Experte für Funktionsdiagnostik',
                    date: '02./03. Oktober 2026',
                    label: 'Funktion',
                    color: 'bg-amber-100 text-amber-700'
                  }, {
                    title: 'Modul 4: Experte für Praxiserfolg und Führung',
                    date: '04./05. Dezember 2026',
                    label: 'Champions League',
                    color: 'bg-purple-100 text-purple-700'
                  }].map((modul, idx) => <div key={idx} className="flex flex-col md:flex-row md:items-center justify-between p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-[#59d0d4]/30 transition-colors" data-id="element-1016">
                        <div className="mb-4 md:mb-0" data-id="element-1017">
                          <h3 className="text-lg font-extrabold text-slate-700 mb-1" data-id="element-1018">
                            {modul.title}
                          </h3>
                          <p className="text-[#3b7780] font-bold" data-id="element-1019">
                            {modul.date}
                          </p>
                        </div>
                        <div className={`text-sm font-extrabold px-4 py-2 rounded-lg ${modul.color}`} data-id="element-1020">
                          {modul.label}
                        </div>
                      </div>)}
                  </div>

                  <p className="text-sm text-slate-400 font-medium mt-6" data-id="element-1021">
                    Freitag: 14.00–19.00 Uhr | Samstag: 09.00–16.30 Uhr
                  </p>
                </div>
              </ScrollReveal>

              {/* Dinner & Networking */}
              <ScrollReveal variant="up" data-id="element-1022">
                <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-slate-100" data-id="element-1023">
                  <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-1024">
                    <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-1025">
                      <div className="flex items-center gap-3 mb-6" data-id="element-1026">
                        <UtensilsIcon className="w-6 h-6 text-[#59d0d4]" data-id="element-1027" />
                        <h2 className="text-2xl font-extrabold text-slate-700" data-id="element-1028">
                          Dinner & Networking
                        </h2>
                      </div>
                      <p className="text-slate-600 font-medium leading-relaxed mb-4" data-id="element-1029">
                        Am Freitagabend eines jeden Kurses gibt es ein
                        gemeinsames Dinner in eines der angesagten Restaurants
                        der Stadt – inklusive Weinbegleitung und 3-Gang Menü.
                      </p>
                      <p className="text-slate-600 font-medium leading-relaxed" data-id="element-1030">
                        Genießen Sie den Abend in stilvollem Ambiente, tauschen
                        Sie sich mit Kolleginnen und Kollegen aus und knüpfen
                        Sie wertvolle Kontakte – ganz entspannt bei
                        ausgezeichneter Küche und guten Gesprächen.
                      </p>
                    </div>
                    <div className="h-64 md:h-auto bg-slate-200" data-id="element-1031">
                      <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="Dinner & Networking" className="w-full h-full object-cover" data-id="element-1032" />
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>

            {/* Sidebar Column */}
            <div className="lg:col-span-4 space-y-6 md:space-y-8" data-id="element-1033">
              <div className="sticky top-32" data-id="element-1034">
                {/* Pricing Card */}
                <ScrollReveal variant="up" data-id="element-1035">
                  <div className="bg-[#1a1a1a] rounded-3xl p-8 text-white shadow-xl mb-8 relative overflow-hidden border border-slate-800" data-id="element-1036">
                    <h3 className="text-xl font-extrabold mb-2 text-slate-300" data-id="element-1037">
                      Ihre Investition
                    </h3>
                    <h4 className="text-2xl font-extrabold mb-6 text-white" data-id="element-1038">
                      Intensiv Curriculum
                    </h4>

                    <div className="mb-8" data-id="element-1039">
                      <div className="flex items-baseline gap-2 mb-2" data-id="element-1040">
                        <span className="text-4xl font-extrabold text-[#59d0d4]" data-id="element-1041">
                          5.490 €
                        </span>
                      </div>
                      <p className="text-sm text-slate-400 font-medium mb-4" data-id="element-1042">
                        zzgl. 19% MwSt. (inklusive Verpflegung und
                        Abendprogramm)
                      </p>
                      <div className="bg-white/10 p-4 rounded-xl border border-white/5" data-id="element-1043">
                        <p className="text-sm text-slate-300 font-medium flex justify-between" data-id="element-1044">
                          <span data-id="element-1045">GESAMT inkl. MwSt:</span>
                          <span className="font-bold text-white" data-id="element-1046">
                            6.533,10 €
                          </span>
                        </p>
                      </div>
                    </div>

                    <button onClick={openBooking} className="flex items-center justify-center w-full px-6 py-4 bg-[#59d0d4] text-[#1a1a1a] hover:bg-[#4abfc3] font-extrabold rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(89,208,212,0.3)] hover:scale-105 group relative z-10 uppercase tracking-wider" data-id="element-1047">
                      <span data-id="element-1048">Jetzt Kursplatz sichern!</span>
                      <ArrowRightIcon className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1049" />
                    </button>
                  </div>
                </ScrollReveal>

                {/* Course Contents List */}
                <ScrollReveal variant="up" delay={200} data-id="element-1050">
                  <div className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100" data-id="element-1051">
                    <h3 className="text-xl font-extrabold text-slate-700 mb-6" data-id="element-1052">
                      Aus dem Inhalt
                    </h3>
                    <ul className="space-y-4" data-id="element-1053">
                      {['A-Kurs: Weiße Ästhetik', 'B-Kurs: Rote Ästhetik', 'C-Kurs: Funktion', 'D-Kurs: Die 7 Säulen des Praxiserfolges', 'E-Kurs: Alignertherapie'].map((item, idx) => <li key={idx} className="flex items-center p-3 rounded-xl bg-slate-50 border border-slate-100" data-id="element-1054">
                          <div className="bg-[#3b7780] text-white w-8 h-8 rounded-lg flex items-center justify-center font-bold mr-4 flex-shrink-0" data-id="element-1055">
                            {item.charAt(0)}
                          </div>
                          <span className="text-slate-700 font-bold" data-id="element-1056">
                            {item.split(': ')[1]}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </ScrollReveal>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1057" />
    </div>;
}